import { Input } from '@driftt/tide-core-legacy'
import Select from 'react-select-plus'

import AvailabilitySlotSelect from '../AvailabilitySlotSelect'
import BufferSettings from '../BufferSettings'
import { TIMEZONE_OPTIONS } from 'components/Customize/Availability/Constants'

const Section = props => <div {...props} className={props.className} />

const MeetingSettings = ({
  meetingSettings,
  handleAddSlotClick,
  handleRemoveSlotClick,
  handleSelectDayOfWeek,
  handleSelectStartTime,
  handleSelectEndTime,
  errorMessageKey,
  settingsErrorMessages,
  showRemoveSlotUI,
  handleSelectTimezone,
}) => {
  return (
    <div className="meeting-settings">
      <Section>
        <div className="drift-form">
          {!!errorMessageKey && (
            <div className="error-messages">{settingsErrorMessages[errorMessageKey]}</div>
          )}

          <div className="meeting-subsettings">
            {meetingSettings.availability.map((value, slot) => {
              const { dayOfWeek, startTime, endTime } = value.toJS()
              return (
                <AvailabilitySlotSelect
                  key={`${value}-${slot}`}
                  index={slot}
                  dayOfWeek={dayOfWeek}
                  startTime={startTime}
                  endTime={endTime}
                  onSelectDayOfWeek={handleSelectDayOfWeek}
                  onSelectStartTime={handleSelectStartTime}
                  onSelectEndTime={handleSelectEndTime}
                  onRemove={handleRemoveSlotClick}
                  hideRemove={!showRemoveSlotUI}
                />
              )
            })}
            <div className="add-time-slot">
              <a onClick={handleAddSlotClick}>+ Add Time Slot</a>
            </div>
          </div>
          <BufferSettings />
          <div className="flex">
            <div className="timezone-picker">
              <label className="settings-label">
                Your Timezone
                <Select
                  value={meetingSettings.timezone}
                  searchable={true}
                  clearable={false}
                  options={TIMEZONE_OPTIONS}
                  onChange={handleSelectTimezone}
                />
              </label>
            </div>
          </div>
        </div>
      </Section>
    </div>
  )
}

export default MeetingSettings



// WEBPACK FOOTER //
// ./src/scripts/components/settings/meetings/AvailabilitySettings/component.js